import React from "react";
import {Row, Col, Skeleton} from "antd";
import useFetch from "hooks/fetch";
import {Client} from "interfaces";
import data from "./data";
import Lazyload from "react-lazyload";

const ClientComponent : React.FC = () => {

    const [isLoading, datasource] = useFetch("client", "desc");

    return (
        <section className={"main-client"}>
            <div id={"client"} className={"public-container"}>
                <Row gutter={[50, 10]}>
                    <Col md={8} sm={24} xs={24}>
                        <div className={"section-heading"}>
                            <h2 className={"title"}>{data.client.id.title}</h2>
                        </div>
                    </Col>
                    <Col md={16} sm={24} xs={24}>
                        <div className={"client-list"}>
                            <p className={"subtitle"}>{data.client.id.subTitle}</p>
                            <Row gutter={[20, 50]} justify="space-around" align="middle">
                                {
                                    (isLoading ? new Array(25).fill(1, 0, 25) : datasource)
                                        .map((item : Client, x) => (
                                            <Col lg={4} md={4} sm={8} xs={8} key={x}>
                                                <div style={{textAlign: "center"}}>
                                                    {
                                                        isLoading
                                                            ? <Skeleton.Avatar size={100} shape={"square"} active={true} />
                                                            :<Lazyload height={"100%"} once={true}>
                                                                <img width={100} src={item.image.url} alt={item.title} />
                                                            </Lazyload>
                                                    }
                                                </div>
                                            </Col>
                                        ))
                                }
                            </Row>
                        </div>
                    </Col>
                </Row>
            </div>
        </section>
    )
}

export default React.memo(ClientComponent);